(function (app) {

    var AvailablePaymentOptions = Backbone.Collection.extend({
        model: Backbone.Model,
        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function (data) {
            this.update(data.AvailablePaymentOptions);
        },

        isOptionApplicable: function (targetPaymentOption) {
            if (!!targetPaymentOption) {
                var paymentOption = targetPaymentOption.toLowerCase();
                return this.models.some(function (option) {
                    return option.get('Name').toLowerCase() === paymentOption;
                });
            }

            return false;
        }
    });

    app.models = _.extend({ availablePaymentOptions: new AvailablePaymentOptions() }, app.models);
})(app);